import React from "react"

const LocationMarker = () => (
	<svg width="14" height="18" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M7 0c3.866 0 7 3.237 7 7.23 0 2.66-2.333 6.25-7 10.77-4.667-4.519-7-8.109-7-10.77C0 3.236 3.134 0 7 0Zm-.15 4.278a2.572 2.572 0 1 0 0 5.144 2.572 2.572 0 0 0 0-5.144Z"
			fill="#3776A5"
		/>
	</svg>
)

export default LocationMarker
